var map = {
	"./armory.png": 256,
	"./armory_org.png": 4155,
	"./blacksmith.png": 2252,
	"./blacksmith_org.png": 7583,
	"./clanhall.png": 8219,
	"./clanhall_org.png": 4832,
	"./fightingpit.png": 7653,
	"./fightingpit_org.png": 1554,
	"./house.png": 4396,
	"./house_org.png": 1951,
	"./market.png": 6390,
	"./market_org.png": 8833,
	"./tower.png": 8163,
	"./tower_org.png": 9352,
	"./workshop.png": 7573,
	"./workshop_org.png": 4866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7393;